import { useContext, useEffect, useState, useCallback } from "react";
import { Formik, Form, ErrorMessage } from "formik"
import * as Yup from 'yup';
import { EditableContext } from "common/EditableContextProvider";
import { ApiConnector } from "common/ApiConnector";

export const FormComponent = () => {
    const { context } = useContext(EditableContext);
    const { FormBase } = context;
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const defaultItem = {
        id: 0,
        name: "",
        file: null
    }
    // const [file, setFile] = useState(null);

    useEffect(() => {
        setInitialValues(getInitialValues());
    }, [context.editID]);

    const getInitialValues = useCallback(
        () => {
            let it = context.getItemSelected();
            if (!it) { it = defaultItem; }
            else { it = { ...it }; }
            return it;
        }, [context.editID]);

    const validateSchema = Yup.object({
        name: Yup.string()
            .required('El campo es obligatorio'),
        file: Yup.mixed()
            .required('Archivo requerido')
            .test(
                "file",
                "Archivo no soportado",
                value => {
                    if(!value) { return false; }
                    const allowedTypes = ["image/jpeg","image/png","image/gif","application/pdf"];
                    return allowedTypes.includes(value.type);
                }
            ).test(
                "file",
                "El archivo debe ser menor a 5Mb.",
                (value) => {
                    return value.size <= (5 * 1024 * 1024);
                }
            )
    });

    const handleSubmit = async (values, formik) => {
        try {
            setIsLoading(true);
            //if(!file) { formik.setFieldError('file', 'El archivo es requerido.'); return; }
            let id = await context.saveItem(values);
            if (id) {
                formik.setFieldValue('id', id);
                setInitialValues(prev => ({...prev, ...values, id: id}));
                // setFile(null);
            } else { setInitialValues(prev => ({...prev, ...values})); }
        } catch (error) {
            const { errors } = error.response.data;
            let keys = Object.keys(errors);
            keys.forEach((key) => {
                formik.setFieldError(key, errors[key][0]);
            });
        }
        finally { setIsLoading(false); }
    }

    const FileViewer = ({filename}) => {
        if(!filename) { return; }

        let parts = filename.split(".");
        let name = parts[0];
        let ext = parts[1];

        switch (ext) {
            case "jpg":
            case "png":
            case "gif":
                return (
                    <div className="text-center">
                        <img
                            className="rounded my-1"
                            style={{ maxHeight: "200px" }}
                            src={`${ApiConnector.defaults.baseURL}/storage/files/${filename}`}
                        />
                    </div>
                )
            case "pdf":
                return (
                    <>
                        <a className="ms-1" href={`/storage/files/${filename}`} download>(Descargar)</a>
                    </>
                )
            default: break;
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validateSchema}
            enableReinitialize={true}
        >
            {
                (formik) => (
                    <Form>
                        <fieldset disabled={FormBase.isLoading}>
                            <div className="mb-2">
                                <FormBase.FormTextField formik={formik} label="Nombre" id="name" required={true} />
                            </div>
                            <div className="mb-2">
                                <label htmlFor="">Archivo</label>
                                {
                                    (formik.values.id)? (
                                        <div className="border my-1 py-1 px-2">
                                            <div className="">
                                                { formik.values.path }
                                            </div>
                                            <FileViewer filename={formik.values.path} />
                                        </div>
                                    ) : (
                                        <>
                                            <input type="file" className="form-control form-control-sm" name="file" id="file"
                                                // onChange={(e) => setFile(e.target.files[0])}
                                                onChange={(e) => formik.setFieldValue('file', e.target.files[0])}
                                                accept="image/jpeg, image/png, image/gif, application/pdf"
                                                required />
                                            <ErrorMessage name="file" component={FormBase.FormError} />
                                        </>
                                    )
                                }
                            </div>
                            <div className="mb-2">
                                <div className="row">
                                    <div className="col">
                                        <button type="button" className="btn btn-sm btn-danger w-100"
                                            onClick={() => context.modalBase.close()}
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button type="submit" className="btn btn-sm btn-dark w-100"
                                            disabled={isLoading || !formik.dirty}
                                        >
                                            {isLoading ? "Guardando..." : "Guardar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </Form>
                )
            }

        </Formik>
    )

}
